import en from "./en.json";
import es from "./es.json";
import en_US from "./en-US.json";

// Define the structure for translation resources
export interface TranslationResource {
  [key: string]: string;
}

// Define the structure for a single language with its translation
export interface LanguageTranslation {
  translation: TranslationResource;
}

// Define the structure for the complete translations object
export interface Translations {
  [languageCode: string]: LanguageTranslation;
}

export const translation: Translations = {
  en: {
    translation: en
  },
  "en-US": {
    translation: en_US
  },
  es: {
    translation: es
  }
};

export const defaultLanguage = "en";

/**
 * Gets the fallback language for a given language code
 * @param language string language code
 * @returns string language code if exist in translation object, else return base language code if exist in translation object, else return default language code
 */
export const getFallbackLanguage = (language: string) => {
  if (translation[language]) {
    return language;
  }

  if (language.includes("-")) {
    const baseLang = language.split("-")[0];
    if (translation[baseLang]) {
      return baseLang;
    }
  }

  return defaultLanguage;
};
